import { Stack, Table, TableBody, TableContainer } from "@mui/material";
import RTStructHeader from "@pages/OrderTracker/pages/RTStructTable/RTStructHeader";
import RTStructRow from "@pages/OrderTracker/pages/RTStructTable/RTStructRow";
import { RtStructOut } from "@providers/hop-ord-server/api";

const RTStructTable = ({
  data,
  onSelect,
  selectedId,
  changeOrdering,
}: {
  data: RtStructOut[];
  onSelect: (id: number) => void;
  selectedId: number;
  changeOrdering: (ordering: "asc" | "desc") => void;
}) => {
  return (
    <Stack
      direction="column"
      sx={{
        gap: 1,
      }}
    >
      <RTStructHeader changeOrdering={changeOrdering} />

      <TableContainer
        sx={{ overflow: "auto", maxHeight: "300px", width: "100%" }}
      >
        <Table>
          <TableBody>
            {data.map((item, index) => (
              <RTStructRow
                key={item.id}
                data={item}
                onSelect={onSelect}
                selected={selectedId === item.id}
                isLastRow={index === data.length - 1}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Stack>
  );
};

export default RTStructTable;
